type ToolbarButtonBadge = { isActive: boolean; content?: number };

/**
 * The accessible name of a toolbar icon button. An aria-label replaces the name the button's content
 * would give it, and the count badge is a sibling of the button, so an active count has to be folded
 * into the name or a screen reader announces the button without it. A plain bullet (no content) adds
 * nothing.
 */
export const getToolbarButtonName = (
  label: string | undefined,
  badge?: ToolbarButtonBadge
) =>
  label !== undefined && badge?.isActive && badge.content !== undefined
    ? `${label}: ${badge.content}`
    : label;
